module.exports = __webpack_public_path__ + "img/logo-resonite.854c451a.svg";